<template>
  <Modal title="变更内勤人员" v-model="visible" width="700" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" class="page-form less" :label-width="85">
        <FormItem prop="indoorStaffId" label="内勤人员" :rules="$units.formRule.required('请选择内勤人员')">
          <Select v-model="formData.indoorStaffId" filterable transfer clearable>
              <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
          <Button type="text" @click="visible = false">取消</Button>
          <Button type="primary" @click="save">确认</Button>
      </div>
  </Modal>
</template>

<script>
export default {
  data() {
      return {
          visible: false,
          userList:[],
          formData: {
            id:'',
            indoorStaffId:''
          },

      };
  },
  methods: {
      getUserList(){
        this.$http({
          type: "POST",
          url: "/buz/userBase/getByOrgIds",
          data: {
            type:2
          }
        }).then(res => {
          this.userList = res.data;
        })
      },
      open(data) {
        console.log(data);
          this.visible = true;
          this.getUserList()
          this.$refs.form && this.$refs.form.resetFields();
          this.formData.id = data.id
          this.formData.indoorStaffId = data.indoorStaffId
      },
      save(){
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$http({
              url: '/buz/usersExt/updateIndoorStaff',
              type: 'post',
              data: {
                ...this.formData
              }
            }).then(res => {
              this.$notice.success('保存成功');
              this.visible = false;
              this.$parent.getList();
            });
          }
        })
      }
      
  }
};
</script>
<style lang="scss" scoped>

</style>
